import gql from "graphql-tag";

export const createSurveyMutation = gql`
  mutation createSurvey(
    $title: String!
    $text: String!
    $url: String!
    $startsAt: Timestamp!
    $endsAt: Timestamp!
    $maxShows: Int
  ) {
    createSurvey(
      title: $title
      text: $text
      url: $url
      startsAt: $startsAt
      endsAt: $endsAt
      maxShows: $maxShows
    ) {
      id
    }
  }
`;
